(function () {
  function sporttapeRegiosApi() {
    return window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0
      ? window.RegiosDOPP.api.v0
      : null;
  }

  function sporttapeIsPdp() {
    return !!(
      document.querySelector('[data-product-json]') &&
      document.getElementById('variant_sale')
    );
  }

  function sporttapeAmountToCents(amount) {
    return Math.round(Number(amount) * 100);
  }

  function sporttapeCurrencyFormat() {
    if (!window.themeVariables || !window.themeVariables.settings) {
      return null;
    }

    return window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
  }

  function sporttapeFormatPrice(cents, cf) {
    if (typeof window.sporttapeFormatMoney === 'function') {
      return window.sporttapeFormatMoney(cents, cf);
    }

    if (typeof formatMoney === 'function') {
      return formatMoney(cents, cf);
    }

    return null;
  }

  function sporttapeCanFormatPrices(cf) {
    return !!cf && !!sporttapeFormatPrice(0, cf);
  }

  function sporttapeReplaceMoneyAfterSrOnly(hostEl, moneyStr) {
    const sr = hostEl.querySelector(':scope > .sr-only');
    if (sr) {
      let node = sr.nextSibling;
      while (node) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      sr.insertAdjacentHTML('afterend', moneyStr);
      return;
    }

    hostEl.textContent = moneyStr;
  }

  function sporttapeGetSelectedVariantFromDom() {
    const jsonEl = document.querySelector('[data-product-json]');
    const form = document.querySelector(
      'form[id^="product-form"], form[is="product-form"]'
    );
    if (!jsonEl || !form) {
      return null;
    }

    try {
      const data = JSON.parse(jsonEl.textContent);
      const idInput = form.querySelector('[name="id"]');
      const productIdInput = form.querySelector('[name="product-id"]');
      if (!idInput || !data.variants) {
        return null;
      }

      const variantId = parseInt(idInput.value, 10);
      const variant = data.variants.find(function (entry) {
        return entry.id === variantId;
      });
      if (!variant) {
        return null;
      }

      const productId = productIdInput
        ? parseInt(productIdInput.value, 10)
        : parseInt(
            data.selected_or_first_available_variant &&
              data.selected_or_first_available_variant.product_id,
            10
          );

      return {
        id: variant.id,
        price: variant.price,
        productId: productId,
        variant: variant,
      };
    } catch (error) {
      return null;
    }
  }

  async function sporttapeFetchRegiosPrices(api, selected) {
    if (api.productPage && api.productPage.calculateDiscountedPrices) {
      return api.productPage.calculateDiscountedPrices({
        variantId: selected.id,
        quantity: 1,
      });
    }

    if (!selected.productId) {
      return null;
    }

    return api.calculateDiscountedPrices({
      productId: selected.productId,
      variantId: selected.id,
      regularPriceInCents: selected.price,
      quantity: 1,
    });
  }

  function sporttapeRegiosDisplayCents(incCents, ex) {
    const n = parseInt(incCents, 10);
    if (!n || isNaN(n)) {
      return 0;
    }

    if (!ex) {
      return n;
    }

    return window.sporttapeExVatCents
      ? window.sporttapeExVatCents(n)
      : Math.round(n / 1.2);
  }

  function sporttapeFindPdpCompareEl() {
    return (
      document.querySelector(
        'compare-at-price[data-made-visible-by-regios-dopp]'
      ) ||
      document.querySelector('.price-list compare-at-price') ||
      document.querySelector('compare-at-price[data-sporttape-inc-cents]') ||
      document.querySelector('compare-at-price')
    );
  }

  function sporttapeStoreRegiosPdpPrices(saleInc, regularInc) {
    window.__sporttapeRegiosPdpPrices = {
      saleInc: saleInc,
      regularInc: regularInc,
    };

    const priceList = document.querySelector('.price-list');
    if (priceList) {
      priceList.setAttribute(
        'data-sporttape-regios-regular-inc-cents',
        String(regularInc)
      );
      priceList.setAttribute(
        'data-sporttape-regios-sale-inc-cents',
        String(saleInc)
      );
    }
  }

  function sporttapeReadStoredRegularInc(compareEl) {
    if (window.__sporttapeRegiosPdpPrices?.regularInc) {
      return window.__sporttapeRegiosPdpPrices.regularInc;
    }

    const priceList = document.querySelector('.price-list');
    if (priceList) {
      const fromList = parseInt(
        priceList.getAttribute('data-sporttape-regios-regular-inc-cents'),
        10
      );
      if (!isNaN(fromList) && fromList > 0) {
        return fromList;
      }
    }

    if (compareEl) {
      const fromCompare = parseInt(
        compareEl.getAttribute('data-sporttape-regios-regular-cents'),
        10
      );
      if (!isNaN(fromCompare) && fromCompare > 0) {
        return fromCompare;
      }

      const fromInc = parseInt(
        compareEl.getAttribute('data-sporttape-inc-cents'),
        10
      );
      if (!isNaN(fromInc) && fromInc > 0) {
        return fromInc;
      }
    }

    return 0;
  }

  function sporttapeUpdateCompareAtPrice(regularInc, saleInc, ex, cf) {
    const compareEl = sporttapeFindPdpCompareEl();
    if (!compareEl || !sporttapeCanFormatPrices(cf)) {
      return;
    }

    if (!regularInc || regularInc <= saleInc) {
      compareEl.setAttribute('hidden', '');
      compareEl.style.display = 'none';
      compareEl.setAttribute('data-sporttape-inc-cents', '0');
      compareEl.removeAttribute('data-sporttape-regios-managed');
      return;
    }

    sporttapeStoreRegiosPdpPrices(saleInc, regularInc);

    const compareDisp = sporttapeRegiosDisplayCents(regularInc, ex);

    compareEl.removeAttribute('hidden');
    compareEl.style.display = '';
    compareEl.setAttribute('data-sporttape-inc-cents', String(regularInc));
    compareEl.setAttribute('data-sporttape-regios-regular-cents', String(regularInc));
    compareEl.setAttribute('data-sporttape-regios-managed', 'true');
    compareEl.setAttribute('data-vat-display', ex ? 'ex' : 'inc');
    sporttapeReplaceMoneyAfterSrOnly(
      compareEl,
      sporttapeFormatPrice(compareDisp, cf)
    );
  }

  function sporttapeSyncCompareFromStored(ex, cf) {
    const compareEl = sporttapeFindPdpCompareEl();
    if (!compareEl || !sporttapeCanFormatPrices(cf)) {
      return false;
    }

    const stored = window.__sporttapeRegiosPdpPrices;
    const saleInc = stored?.saleInc || 0;
    const regularInc = sporttapeReadStoredRegularInc(compareEl);
    if (!regularInc || (saleInc && regularInc <= saleInc)) {
      return false;
    }

    sporttapeUpdateCompareAtPrice(regularInc, saleInc || regularInc, ex, cf);
    return true;
  }

  function sporttapeUpdatePerRoll(regularInc, saleInc, ex, cf, variant) {
    const rollEl = document.getElementById('variant_roll');
    if (!rollEl || !variant || !sporttapeCanFormatPrices(cf)) {
      return;
    }

    const packSize = window.sporttapeGetVariantPackSize
      ? window.sporttapeGetVariantPackSize(variant)
      : 0;
    if (packSize <= 0) {
      return;
    }

    rollEl.removeAttribute('hidden');
    rollEl.style.display = '';

    const onSale = regularInc > saleInc;
    const baseInc = onSale ? saleInc : regularInc;
    const perUnitInc = Math.round(baseInc / packSize);
    const rollDisp = window.sporttapeGetPerUnitDisplayCents
      ? window.sporttapeGetPerUnitDisplayCents(
          Object.assign({}, variant, { price: baseInc }),
          ex
        )
      : sporttapeRegiosDisplayCents(perUnitInc, ex);
    const rollSuffix = rollEl.getAttribute('data-sporttape-roll-suffix') || '';

    rollEl.setAttribute('data-sporttape-roll-inc-cents', String(perUnitInc));
    rollEl.setAttribute('data-sporttape-roll-base-inc-cents', String(baseInc));
    rollEl.textContent = sporttapeFormatPrice(rollDisp, cf) + rollSuffix;
    rollEl.removeAttribute('data-sporttape-member-applied');
  }

  function sporttapeSyncPerRollFromStored(ex, cf) {
    const stored = window.__sporttapeRegiosPdpPrices;
    const selected = sporttapeGetSelectedVariantFromDom();
    if (!stored || !selected || !sporttapeCanFormatPrices(cf)) {
      return false;
    }

    sporttapeUpdatePerRoll(
      stored.regularInc,
      stored.saleInc,
      ex,
      cf,
      selected.variant
    );
    return true;
  }

  function sporttapeSyncRegiosPdpFromStored(ex, cf) {
    if (!sporttapeCanFormatPrices(cf)) {
      return false;
    }

    const stored = window.__sporttapeRegiosPdpPrices;
    const selected = sporttapeGetSelectedVariantFromDom();
    if (!stored || !selected) {
      return false;
    }

    const variantSale = document.getElementById('variant_sale');
    if (variantSale) {
      const saleDisp = sporttapeRegiosDisplayCents(stored.saleInc, ex);
      variantSale.setAttribute('data-sporttape-inc-cents', String(stored.saleInc));
      variantSale.setAttribute('data-sporttape-regios-managed', 'true');
      variantSale.setAttribute('data-vat-display', ex ? 'ex' : 'inc');
      sporttapeReplaceMoneyAfterSrOnly(
        variantSale,
        sporttapeFormatPrice(saleDisp, cf)
      );
    }

    sporttapeUpdateCompareAtPrice(stored.regularInc, stored.saleInc, ex, cf);
    sporttapeUpdatePerRoll(
      stored.regularInc,
      stored.saleInc,
      ex,
      cf,
      selected.variant
    );
    return true;
  }

  function sporttapeGuardRegiosPricePaint() {
    if (!sporttapeIsPdp() || window.__sporttapeRegiosPriceGuard) {
      return;
    }

    window.__sporttapeRegiosPriceGuard = true;
    let debounceTimer;

    function scheduleReapply() {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        if (!window.sporttapeRegiosManagesPdp) {
          return;
        }

        const ex =
          typeof window.sporttapeShouldShowExVat === 'function'
            ? window.sporttapeShouldShowExVat()
            : document.documentElement.getAttribute('data-vat-mode') === 'ex';
        const cf = sporttapeCurrencyFormat();
        if (sporttapeSyncRegiosPdpFromStored(ex, cf)) {
          return;
        }
        window.sporttapeApplyRegiosPdpVat();
      }, 40);
    }

    ['variant_sale', 'variant_roll'].forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) {
        return;
      }

      new MutationObserver(scheduleReapply).observe(el, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    });

    const compareEl = sporttapeFindPdpCompareEl();
    if (compareEl) {
      new MutationObserver(scheduleReapply).observe(compareEl, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    const priceList = document.querySelector('.price-list');
    if (priceList) {
      new MutationObserver(scheduleReapply).observe(priceList, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  window.sporttapeSyncRegiosCompareFromStored = sporttapeSyncCompareFromStored;
  window.sporttapeSyncRegiosPdpFromStored = sporttapeSyncRegiosPdpFromStored;

  window.sporttapeRegiosActive = function () {
    return !!sporttapeRegiosApi();
  };

  window.sporttapeApplyRegiosPdpVat = async function () {
    const api = sporttapeRegiosApi();
    const cf = sporttapeCurrencyFormat();
    if (!api || !sporttapeIsPdp() || !sporttapeCanFormatPrices(cf)) {
      return false;
    }

    const selected = sporttapeGetSelectedVariantFromDom();
    if (!selected) {
      return false;
    }

    let result;
    try {
      result = await sporttapeFetchRegiosPrices(api, selected);
    } catch (error) {
      return false;
    }

    if (!result || !result.salePrice) {
      return false;
    }

    const ex =
      typeof window.sporttapeShouldShowExVat === 'function'
        ? window.sporttapeShouldShowExVat()
        : document.documentElement.getAttribute('data-vat-mode') === 'ex';
    const saleInc = sporttapeAmountToCents(result.salePrice.amount);
    const regularInc = sporttapeAmountToCents(result.regularPrice.amount);
    const variantSale = document.getElementById('variant_sale');

    if (!variantSale) {
      return false;
    }

    sporttapeStoreRegiosPdpPrices(saleInc, regularInc);

    const saleDisp = sporttapeRegiosDisplayCents(saleInc, ex);

    variantSale.setAttribute('data-sporttape-inc-cents', String(saleInc));
    variantSale.setAttribute('data-sporttape-regios-managed', 'true');
    variantSale.setAttribute('data-vat-display', ex ? 'ex' : 'inc');
    variantSale.removeAttribute('data-sporttape-member-applied');
    sporttapeReplaceMoneyAfterSrOnly(
      variantSale,
      sporttapeFormatPrice(saleDisp, cf)
    );

    sporttapeUpdateCompareAtPrice(regularInc, saleInc, ex, cf);
    sporttapeUpdatePerRoll(regularInc, saleInc, ex, cf, selected.variant);

    if (typeof window.sporttapeApplyMembershipPricing === 'function') {
      window.sporttapeApplyMembershipPricing();
    }

    return true;
  };

  window.sporttapeOnRegiosVariantChange = function (variant) {
    if (!sporttapeRegiosApi() || !variant) {
      return;
    }

    window.dispatchEvent(
      new CustomEvent('regios-dopp:variant-change', {
        detail: {
          selectedVariant: variant,
          quantity: 1,
        },
      })
    );

    window.setTimeout(function () {
      window.sporttapeApplyRegiosPdpVat();
    }, 50);
  };

  function sporttapeWrapRefreshListedPrices() {
    if (window.sporttapeRefreshListedPrices?.__sporttapeRegiosWrapped) {
      return;
    }

    if (!window.sporttapeRefreshListedPrices) {
      window.setTimeout(sporttapeWrapRefreshListedPrices, 100);
      return;
    }

    const original = window.sporttapeRefreshListedPrices;
    window.sporttapeRefreshListedPrices = function () {
      if (window.sporttapeRegiosManagesPdp && sporttapeIsPdp()) {
        window.sporttapeApplyRegiosPdpVat().finally(function () {
          window.sporttapeRegiosSkipPdpRefresh = true;
          original();
          window.sporttapeRegiosSkipPdpRefresh = false;
        });
        return;
      }

      original();
    };
    window.sporttapeRefreshListedPrices.__sporttapeRegiosWrapped = true;
  }

  function sporttapeScheduleVatApply() {
    if (!window.sporttapeRegiosActive() || !sporttapeIsPdp()) {
      return;
    }

    window.sporttapeRegiosManagesPdp = true;
    window.sporttapeApplyRegiosPdpVat();

    [100, 250, 500, 750, 1500, 2500, 4000].forEach(function (delay) {
      window.setTimeout(function () {
        if (window.sporttapeRegiosManagesPdp && sporttapeIsPdp()) {
          window.sporttapeApplyRegiosPdpVat();
        }
      }, delay);
    });
  }

  function sporttapeInitRegiosBridge() {
    sporttapeWrapRefreshListedPrices();
    sporttapeGuardRegiosPricePaint();
    sporttapeScheduleVatApply();
  }

  function sporttapeWhenRegiosReady(callback) {
    if (sporttapeRegiosApi()) {
      callback();
      return;
    }

    window.addEventListener('regios-dopp:api-initialized', callback);
  }

  function sporttapeWhenPricingReady(callback) {
    if (sporttapeCanFormatPrices(sporttapeCurrencyFormat())) {
      callback();
      return;
    }

    let attempts = 0;
    const timer = window.setInterval(function () {
      attempts += 1;
      if (sporttapeCanFormatPrices(sporttapeCurrencyFormat()) || attempts >= 50) {
        window.clearInterval(timer);
        callback();
      }
    }, 100);
  }

  function sporttapeBootRegiosBridge() {
    sporttapeWhenPricingReady(function () {
      sporttapeWhenRegiosReady(sporttapeInitRegiosBridge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sporttapeWrapRefreshListedPrices();
      sporttapeBootRegiosBridge();
    });
  } else {
    sporttapeWrapRefreshListedPrices();
    sporttapeBootRegiosBridge();
  }
})();
